(function () {
  document.querySelectorAll('[data-flavors-lola]').forEach(function (section) {
    initCarousel(section);
  });

  function initCarousel(section) {
    var bottlesList = section.querySelector('[data-flavors-bottles]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-flavors-slide]'));
    var details = Array.prototype.slice.call(section.querySelectorAll('[data-flavors-detail]'));
    var prevBtn = section.querySelector('[data-flavors-prev]');
    var nextBtn = section.querySelector('[data-flavors-next]');
    var starsContainer = section.querySelector('[data-flavors-stars]');

    if (!bottlesList || !slides.length) return;

    var total = slides.length;
    var half = Math.floor(total / 2);
    var activeIndex = 0;

    // Night-mode decorative stars: a handful of small sparkles scattered
    // at random positions/sizes/timings across the card. Re-generated
    // (not just re-shown) on every flavor change, so the sky visibly
    // "refreshes" in response to the selection rather than sitting there
    // static — cheap to do since these are just a few small <span>s.
    function spawnStars() {
      if (!starsContainer) return;
      starsContainer.innerHTML = '';

      var count = 14;
      for (var i = 0; i < count; i++) {
        var star = document.createElement('span');
        star.className = 'flavors-lola__star';
        star.textContent = '\u2726'; // ✦ four-pointed sparkle glyph

        // Ring/donut distribution instead of uniform random: an angle
        // plus a radius that's never too small, so stars land away from
        // the center (where the bottle + spotlight already are) and
        // read as framing the product rather than competing with it.
        var angle = Math.random() * Math.PI * 2;
        var radiusX = 30 + Math.random() * 24; // 30-54% from center
        var radiusY = 32 + Math.random() * 26; // 32-58% from center
        var left = 50 + Math.cos(angle) * radiusX;
        var top = 50 + Math.sin(angle) * radiusY;
        left = Math.min(98, Math.max(2, left));
        top = Math.min(96, Math.max(4, top));

        star.style.setProperty('--flavors-lola-star-top', top.toFixed(1) + '%');
        star.style.setProperty('--flavors-lola-star-left', left.toFixed(1) + '%');
        star.style.setProperty('--flavors-lola-star-size', (Math.random() * 16.8 + 14).toFixed(1) + 'px');
        star.style.setProperty('--flavors-lola-star-opacity', (Math.random() * 0.45 + 0.4).toFixed(2));
        star.style.setProperty('--flavors-lola-star-duration', (Math.random() * 2 + 2.5).toFixed(1) + 's');
        star.style.setProperty('--flavors-lola-star-delay', (Math.random() * 1.2).toFixed(2) + 's');
        star.style.setProperty('--flavors-lola-star-drift-x', (Math.random() * 12 - 6).toFixed(1) + 'px');
        starsContainer.appendChild(star);
      }
    }

    spawnStars();

    // Start from whichever slide the server already marked as active
    // (data-offset="0"), matching the initial markup exactly.
    var markedActive = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (markedActive > -1) activeIndex = markedActive;

    function goTo(index) {
      var nextIndex = ((index % total) + total) % total;

      slides.forEach(function (slide, i) {
        var diff = (((i - nextIndex) % total) + total) % total;
        if (diff > half) diff -= total;

        var isActive = diff === 0;
        slide.setAttribute('data-offset', String(diff));
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-current', String(isActive));
      });

      activeIndex = nextIndex;
      updateDetails(activeIndex);
      spawnStars();
    }

    function updateDetails(index) {
      var activeDetail = details.filter(function (d) {
        return d.classList.contains('is-active');
      })[0];
      var nextDetail = details.filter(function (d) {
        return parseInt(d.getAttribute('data-index'), 10) === index;
      })[0];

      if (activeDetail === nextDetail) return;

      if (activeDetail) activeDetail.classList.remove('is-active');
      if (nextDetail) {
        // Brief delay so the fade-out is visible before the new detail
        // fades in — a soft crossfade rather than an instant swap.
        window.setTimeout(function () {
          nextDetail.classList.add('is-active');
        }, 80);
      }
    }

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    // Click a visible side bottle to jump straight to it
    slides.forEach(function (slide) {
      slide.addEventListener('click', function () {
        var index = parseInt(slide.getAttribute('data-index'), 10);
        goTo(index);
      });
    });

    // Keyboard support
    bottlesList.setAttribute('tabindex', '0');
    bottlesList.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(activeIndex + 1);
      }
    });

    // Unified pointer drag: mouse-drag on desktop, touch-swipe on mobile —
    // same input handling either way via the Pointer Events API. Unlike a
    // scrolling track, this carousel only ever shows 3 fixed positions, so
    // a drag simply decides "did the visitor mean to go back or forward?"
    // rather than following the finger continuously.
    var isDragging = false;
    var dragStartX = 0;

    bottlesList.addEventListener('pointerdown', function (event) {
      isDragging = true;
      dragStartX = event.clientX;
      bottlesList.classList.add('is-dragging');
      bottlesList.setPointerCapture(event.pointerId);
    });

    bottlesList.addEventListener('pointerup', function (event) {
      if (!isDragging) return;
      isDragging = false;
      bottlesList.classList.remove('is-dragging');

      var delta = event.clientX - dragStartX;
      var threshold = 40;

      if (delta > threshold) {
        goTo(activeIndex - 1);
      } else if (delta < -threshold) {
        goTo(activeIndex + 1);
      }
    });

    bottlesList.addEventListener('pointercancel', function () {
      isDragging = false;
      bottlesList.classList.remove('is-dragging');
    });

    goTo(activeIndex);
  }
})();